import { ScanLine, CheckCircle2, PackageCheck } from "lucide-react";

const fmt = (iso) => (iso ? new Date(iso).toLocaleString("en-IN", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "—");

export default function Milestones({ order, testId = "milestones" }) {
  if (!order) return null;
  const items = [
    { key: "booked", icon: PackageCheck, label: "Booked", when: order.created_at, where: order.pickup_address ? order.pickup_address.split(",").slice(-2).join(",").trim() : "", done: true },
    { key: "scanned", icon: ScanLine, label: "Scanned at warehouse", when: order.warehouse_received_at, where: order.warehouse_received ? "New Delhi Hub" : "", done: !!order.warehouse_received },
    { key: "delivered", icon: CheckCircle2, label: "Delivered", when: order.delivered_at, where: order.delivered_location, done: !!order.delivered || order.status === "Delivered" },
  ];
  return (
    <div className="grid grid-cols-1 gap-2 sm:grid-cols-3" data-testid={testId}>
      {items.map((m) => (
        <div key={m.key} className={`rounded-xl border p-3 ${m.done ? "border-emerald-200 bg-emerald-50/60" : "border-dashed border-border bg-slate-50/40"}`} data-testid={`${testId}-${m.key}`}>
          <div className={`flex items-center gap-1.5 text-[10px] font-mono-label uppercase tracking-widest ${m.done ? "text-emerald-700" : "text-muted-foreground"}`}><m.icon className="h-3.5 w-3.5" /> {m.label}</div>
          <div className="mt-1 text-sm font-semibold">{m.done ? fmt(m.when) : "Pending"}</div>
          {m.done && m.where && <div className="truncate text-xs text-muted-foreground">{m.where}</div>}
        </div>
      ))}
    </div>
  );
}
